/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
import classNames from 'classnames';
import * as React from 'react';
import Measure from '../../../components/measure/Measure';
import { isDiffMetric } from '../../../helpers/measures';
import { MeasureEnhanced } from '../../../types/types';

interface Props {
  displayLeak?: boolean;
  measure: MeasureEnhanced;
}

export default function FacetMeasureValue({ measure, displayLeak }: Props) {
  if (isDiffMetric(measure.metric.key)) {
    return (
      <div
        className={classNames('domain-measures-value', { 'leak-box': displayLeak })}
        id={`measure-${measure.metric.key}-leak`}
      >
        <Measure
          metricKey={measure.metric.key}
          metricType={measure.metric.type}
          value={measure.leak}
        />
      </div>
    );
  }

  return (
    <div className="domain-measures-value" id={`measure-${measure.metric.key}-value`}>
      <Measure
        metricKey={measure.metric.key}
        metricType={measure.metric.type}
        value={measure.value}
      />
    </div>
  );
}
